module.exports = __webpack_public_path__ + "img/PS4.6237ffe5.png";